import styled from 'styled-components';

import { pxToRem } from '@utils/converters';
import { MakePropertiesRequired, Transient } from '@utils/types';

import { Avatar, AVATARS } from './avatars';

export const BORDER_STYLE = `${pxToRem(2)} solid rgba(0, 0, 0, 0.05)`;
export const BORDER_RADIUS = '12.5%';

export type DesignAvatarProps = {
  src?: string;
  size?: number;
};

export const DesignAvatar = ({ src: userSrc, size = 24 }: DesignAvatarProps) => {
  const src = useParsedDesignAvatar(userSrc);
  return (
    <AvatarWrapper $size={size}>
      <img src={src} alt="" />
    </AvatarWrapper>
  );
};

type SizeProp = Transient<Pick<MakePropertiesRequired<DesignAvatarProps, 'size'>, 'size'>>;

const AvatarWrapper = styled.div<SizeProp>(({ $size }) => {
  const calculatedSize = pxToRem($size);

  return {
    position: 'relative',
    width: calculatedSize,
    height: calculatedSize,
    borderRadius: BORDER_RADIUS,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    img: {
      width: calculatedSize,
      height: calculatedSize,
      borderRadius: BORDER_RADIUS,
    },

    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      borderRadius: BORDER_RADIUS,
      border: BORDER_STYLE,
      pointerEvents: 'none',
    },
  };
});

const DESIGN_AVATAR_IDENTIFIER = '__50SKILLS_DESIGN_AVATAR__';

export const getDesignAvatarUrl = (avatar: Avatar) => `${DESIGN_AVATAR_IDENTIFIER}${avatar}`;

const getRandomDesignAvatar = () => {
  return Object.keys(AVATARS)[Math.floor(Math.random() * Object.keys(AVATARS).length)] as Avatar;
};

export const getRandomAvatarUrl = () => {
  return getDesignAvatarUrl(getRandomDesignAvatar());
};

const useParsedDesignAvatar = (src?: string): string => {
  if (!src) {
    return AVATARS[getRandomDesignAvatar()];
  }
  if (src.includes(DESIGN_AVATAR_IDENTIFIER)) {
    return AVATARS[src.split(DESIGN_AVATAR_IDENTIFIER)[1].split('?')[0] as Avatar];
  }
  return src;
};
